<template>
  <div>
    <CampaignsComponent />
  </div>
</template>

<script>
import CampaignsComponent from './components/Index.vue'

export default {
  name: 'Campaigns',
  components: {
    CampaignsComponent,
  },
}
</script>
